import { createSlice } from "@reduxjs/toolkit";

const bouncedchequesSlice = createSlice({
    name: "bouncedcheques",
    initialState: {
        bouncedchequesDetails: {},
        bouncedchequesError: null,
        bouncedchequesLoading: false,
    },
    reducers: {
        setBouncedChequesDetails: (state, { payload }) => {
            state.bouncedchequesDetails = payload;
        },
        setBouncedChequesError: (state, { payload }) => {
            state.bouncedchequesError = payload;
        },
        setBouncedChequesLoading: (state, { payload }) => {
            state.bouncedchequesLoading = payload;
        },
    }
});

export const { setBouncedChequesDetails, setBouncedChequesError, setBouncedChequesLoading } = bouncedchequesSlice.actions;

export default bouncedchequesSlice.reducer;